import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Button, ButtonGroup, Icon } from 'ui';
import LinkButton from 'components/shared/LinkButton';

const DeleteConfirmationModal = ({ deleteStep, hideModal }) => {
  const handleSubmit = e => {
    e.preventDefault();
    deleteStep();
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={hideModal}
      >
        <div className="ModalTakeover-container JourneyDeleteModal">
          <div className="JourneyDeleteModal-body">
            <form onSubmit={handleSubmit}>
              <div className="JourneyDeleteModal-title">
                {t('journeys.delete_modal.delete_step')}
              </div>
              <div className="JourneyDeleteModal-subtitle">
                {t('journeys.delete_modal.description')}
              </div>
              <ButtonGroup alignEnd className="mt-32">
                <LinkButton type="primary" className="mr-8" onClick={hideModal}>
                  {t('common.cancel')}
                </LinkButton>
                <Button danger type="submit" onClick={deleteStep}>
                  {t('journeys.builder.delete')}
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={hideModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default DeleteConfirmationModal;
